$("a.disabled").on("click", function (e) {
    e.preventDefault();
});

$('table.table td.view a').hover(function () {
    $(this).children('img').attr("src", "/media/85933/view_over.png");
}, function () {
    $(this).children('img').attr("src", "/media/27942/view_on.png");
});

function resizePopup(popupHeight, popupWidth)
{
    adjustedHeight = 0;
    if (ie != undefined || ie != null) {
        adjustedHeight = 40;
    }

    document.getElementById('form-container').style.height = (popupHeight + adjustedHeight) + "px";
    document.getElementById('form-container').style.minHeight = "450px";
}

function getCookie(cName) {
    var cookies = {};
    var val;
    var all = document.cookie;
    if (all === "") {
        return "";
    }
    var list = all.split("; ");
    for (var i = 0; i < list.length; i++) {
        var cookie = list[i];
        var p = cookie.indexOf("=");
        var name = cookie.substring(0, p);
        var value = cookie.substring(p + 1);
        cookies[name] = value;
    }
    for (name in cookies) {
        if (name == cName) {
            val = cookies[name];
            break;
        }
    }
    return val;
}

$(function () {
    if (ie == "7") {
        $('#contour fieldset.pleasesendmeemailupdatesonthefollowing legend').wrapInner('<div />');
    }
});

$(function () {
    $('a.contactFormPopupLink').click(function (e) {
        e.preventDefault();
        var currUrl = window.location.href;
        var formUrl = "/general-contact-form.aspx";
        if (currUrl.indexOf("/investors") != -1) {
            formUrl = "/investors-contact-form.aspx";
        }
        if (currUrl.indexOf("/operations") != -1) {
            formUrl = "/operations-contact-form.aspx";
        }
        if (currUrl.indexOf("/community") != -1) {
            formUrl = "/community-contact-form.aspx";
        }
        if (currUrl.indexOf("/careers") != -1) {
            formUrl = "/careers-contact-form.aspx";
        }
        if ($(document).width() >= '600') {
            $('#modal-form-container').modal('show');
            $('#form-container').attr('src', formUrl);
        } else {
            var cookie = 'launchPage="' + currUrl + '";path=/';
            document.cookie = cookie;
            var newUrl = formUrl + '?altTemplate=FormMobile';
            window.location.href = newUrl;
        }
    });
});

$(function () {
    var defaultLabel = "MM/DD/YYYY";
    var arrivalField = $('#contour .contourField.dateofarrival input[type="text"]');
    var departureField = $('#contour .contourField.dateofdeparture input[type="text"]');
    arrivalField.val(defaultLabel);
    departureField.val(defaultLabel);

    arrivalField.on("focus", function () {
        if (arrivalField.val() == defaultLabel) {
            arrivalField.val("");
        }
    });

    arrivalField.on("blur", function () {
        if (arrivalField.val() == "") {
            arrivalField.val(defaultLabel);
        }
    });

    departureField.on("focus", function () {
        if (departureField.val() == defaultLabel) {
            departureField.val("");
        }
    });

    departureField.on("blur", function () {
        if (departureField.val() == "") {
            departureField.val(defaultLabel);
        }
    });
});

$(document).ready(function() {
	$("body").on("click", "a[href*='/careers-full-email-form.aspx']", customForm);
	$("body").on("click", "a[href*='/community-full-email-form.aspx']", customForm);
	$("body").on("click", "a[href*='/general-full-email-form.aspx']", customForm);
	$("body").on("click", "a[href*='/investors-full-email-form.aspx']", customForm);
	$("body").on("click", "a[href*='/operations-full-email-form.aspx']", customForm);
	function customForm(e) {
		e.preventDefault();
		var path = $(this).get(0).pathname;
		if ($(document).width() >= '600') {
			$('#form-container').attr('src', path);
			$('#modal-form-container').modal('show');
		} else {
			var cookie='launchPage=' + location.pathname + ';path=/';
				document.cookie = cookie;
				var newUrl = path + '?altTemplate=FormMobile';
				window.location.href = newUrl;
		}
	}
	
	/*site search form*/
	$("#searchClose").on("click", function() {
		$("#searchBox").css("width", 24);
		$("#searchTxt, #searchClose").hide();
	});
	
	$('#searchBtn').on("click", function (e) {
		e.preventDefault();
		if ($('#searchBox').width() > 100) {
			var searchString = $('#searchTxt').val();
			if (searchString != "") {
				window.location.href = "/search.aspx?s=" + searchString;
			}
		} else {
			$("#searchBox").css("width", 280);
			$("#searchTxt, #searchClose").fadeIn(300);
		}
	});
	
	$('#searchTxt').keypress(function (event) {
        var keynum;
        if (window.event) {
            keynum = event.keyCode;
        }
        else if (event.which) {
            keynum = event.which;
        }
        if (keynum == 13) {
            event.preventDefault();
            $('#searchBtn').click();
        }
    });
	
		$('#siteSearchText').keypress(function (event) {
        var keynum;
        if (window.event) {
            keynum = event.keyCode;
        }
        else if (event.which) {
            keynum = event.which;
        }
        if (keynum == 13) {
            event.preventDefault();
            $('#siteSearchSubmit').click();
        }
    });
});

